import React from "react";
import { useCurrentPath } from "../../hooks";
import type { AdminRouteMap } from "../../pages/AdminAppPage/types";
import { AdminNavLinks } from "./AdminNavLinks";

export type AdminSideNavProps = {
  routes: AdminRouteMap;
};

export const AdminSideNav: React.FC<AdminSideNavProps> = ({ routes }) => {
  const currentPath = useCurrentPath();

  return (
    <aside className="hidden md:flex fixed left-0 top-20 bottom-0 w-64 bg-card border-r border-border flex-col shrink-0 z-40 shadow-[2px_0_8px_-4px_rgba(0,0,0,0.05)]">
      <nav className="flex-1 py-6 px-4 space-y-1.5 overflow-y-auto">
        <AdminNavLinks
          routes={routes}
          currentPath={currentPath}
          variant="sidebar"
        />
      </nav>
    </aside>
  );
};
